(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["hero-custom-bg-gempages"] && !Shopify.designMode) return;
  try {
    // function to move from blurred sensitive images to visible images
(function() {
  const processedImages = new WeakSet();

  function initSensitiveImages(root) {
    const images = root.querySelectorAll('.drip--hide-image');
    if (!images.length) {
      return;
    }

    images.forEach((image) => {
      if (processedImages.has(image)) {
        return;
      }

      const container =
        image.closest('.element-wrap, .elm, [data-label="Image"]') || image.parentElement;
      if (!container) {
        return;
      }

      const buttons = Array.from(container.querySelectorAll('.drip--view-image-icon'));
      if (!buttons.length) {
        return;
      }

      const [primaryButton, ...duplicateButtons] = buttons;
      duplicateButtons.forEach((btn) => btn.remove());

      if (!primaryButton || primaryButton.dataset.dripInitialized === 'true') {
        return;
      }

      processedImages.add(image);
      primaryButton.dataset.dripInitialized = 'true';

      primaryButton.addEventListener(
        'click',
        () => {
          image.classList.remove('drip--hide-image');
          primaryButton.remove();
        },
        { once: true }
      );
    });
  }

  // This function is used to override gempages with light color text that is not readable ie super light grey text on a white background - Commented out for now
  // function applyTextOverrides(root) {
  //   const paragraphs = root.querySelectorAll(
  //     'div[data-label="Text Block"][data-icon="gpicon-textblock"] .text-edit > p'
  //   );

  //   if (!paragraphs.length) {
  //     return;
  //   }

  //   paragraphs.forEach((paragraph) => {
  //     paragraph.style.setProperty('color', '#000', 'important');
  //   });
  // }

  function ready(callback) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', callback);
    } else {
      callback();
    }
  }

  ready(() => {
    initSensitiveImages(document);
    // applyTextOverrides(document);
  });

  document.addEventListener('shopify:section:load', (event) => {
    initSensitiveImages(event.target);
    // applyTextOverrides(event.target);
  });
})();
  } catch(e) { console.error(e); }
})();

})();
